import { Grid, Divider } from '@mui/material';
import React, { useState, useEffect } from 'react';
import styles from './styles';
import Typography from '@mui/material/Typography';
import OrderDetailsBox from './orderDetailsBox';
import ReturnTripDetailsBox from '../Review/ReturnTripDetailsBox';
import OrderSummary from '../Review/OrderSummary';
import moment from 'moment';

const LBS_PER_KG = 2.20462262;
// Display helper: weight is stored in lbs but can be shown in kg on review.
const formatWeightForDisplay = (weightLbs, unit) => {
  if (weightLbs === '' || weightLbs == null) return '';
  const lbs = Number(weightLbs);
  if (Number.isNaN(lbs)) return `${weightLbs} lb`;
  if (unit === 'kg') {
    const kg = lbs / LBS_PER_KG;
    return `${(Math.round(kg * 100) / 100)} kg`;
  }
  return `${lbs} lb`;
};

const OrderInfo = (props) => {

    const [custRef, setCustRef] = useState("");
    const [intructions, setInstructions] = useState("");

    useEffect(() => {
        setCustRef(props.references.Reference);
    },[props.references])

    useEffect(() => {
            console.log("props.signatureRequired-" + props.signatureRequired);
            console.log("props.pictureRequired-" + props.pictureRequired);
            let inst = props.instructions;
            setInstructions(inst);
    },[props.signatureRequired,props.pictureRequired,props.instructions])        

    function renderButtonImage() {
        if (props.packageImage) return props.packageImage;
    }

    function renderRateImage() {
        if(props.rate.buttonImage){ 
            const base64String = btoa(String.fromCharCode(...new Uint8Array(props.rate.buttonImage.data)));
            const imageSrc= "data:image/svg+xml;base64,"+ base64String;
            return imageSrc;   
        }        
    }

    function getIntructions() {
            let instructions = props.instructions;
            if(props.signatureRequired) {
                instructions = "Signature required " + instructions;
            }
            if(props.pictureRequired) {
                instructions = "Picture required " + instructions;
            }
            return instructions;
    }

    var callInUTC = moment.utc(props.callIn).toDate();
    var callInLocal = moment(callInUTC).local().format('YYYY-MM-DD HH:mm');
    var callInMinsUntil = moment(callInUTC).diff(moment(), 'minutes');
    var callInDisplay = callInMinsUntil <= 2 ? 'Now' : callInLocal;
    var callInColor = callInMinsUntil <= 2 ? '#d32f2f' : undefined;

    var dueByUTC = moment.utc(props.dueBy).toDate();
    var dueByLocal = moment(dueByUTC).local().format('YYYY-MM-DD HH:mm');

    console.log("props props props");
    console.log(props);

    return (
        <div>
          <div style={styles.orderContainer}>
            <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="stretch"
            spacing={2}
            >
                <Grid item xs={12}>
                  <Typography style={styles.sectionTitle}>PICKUP</Typography>
                </Grid>
                {/* Row 1: courier meta */}
                {[
                  { label: 'YOUR NAME', value: props.name },
                  { label: 'PICKUP READY TIME', value: callInDisplay, color: callInColor },
                  { label: 'DUE BY', value: dueByLocal },
                ].map(({ label, value, color }) => (
                  <Grid item xs={12} sm={4} key={label}>
                    <div style={styles.addressCard}>
                      <Typography style={styles.addressCardLabel}>{label}</Typography>
                      <Divider style={{marginBottom: 6}}/>
                      <Typography style={{...styles.addressCardName, ...(color ? { color } : {})}}>{value}</Typography>
                    </div>
                  </Grid>
                ))}

                {/* Row 2: grouped FROM */}
                <Grid item xs={12} sm={6}>
                  <div style={styles.addressCard}>
                    <Typography style={styles.addressCardLabel}>FROM</Typography>
                    <Divider style={{marginBottom: 6}}/>
                    <Typography style={styles.addressCardName}>{props.fromName}</Typography>
                    <Typography style={styles.addressCardValue}>{props.fromAddress}</Typography>
                  </div>
                </Grid>

                {/* grouped TO */}
                <Grid item xs={12} sm={6}>
                  <div style={styles.addressCard}>
                    <Typography style={styles.addressCardLabel}>TO</Typography>
                    <Divider style={{marginBottom: 6}}/>
                    <Typography style={styles.addressCardName}>{props.toName}</Typography>
                    <Typography style={styles.addressCardValue}>{props.toAddress}</Typography>
                  </div>
                </Grid>
                            
                {/* Trip details only shown if there's no return trip */}
                {!props.returnTripService && (
                  <>
                    {/* Package card: image + size label + pieces / weight / rate */}
                    <Grid item xs={12}>
                      <div style={styles.packageCard}>
                        {/* Left: package image + size */}
                        <div style={styles.packageImageBlock}>
                          <img src={renderButtonImage()} alt="Package type" style={styles.packageImage}/>
                          <Typography style={styles.packageSizeLabel}>{props.packageSize}</Typography>
                        </div>
                        {/* Divider */}
                        <Divider orientation="vertical" flexItem style={{margin: '0 16px'}}/>
                        {/* Right: stats */}
                        <div style={styles.packageStats}>
                          <div style={styles.packageStat}>
                            <Typography style={styles.packageStatLabel}>{(props.pieceDescriptionOverride || 'Pieces').toUpperCase()}</Typography>
                            <Typography style={styles.packageStatValue}>{props.pieces}</Typography>
                          </div>
                          <div style={styles.packageStat}>
                            <Typography style={styles.packageStatLabel}>WEIGHT</Typography>
                            <Typography style={styles.packageStatValue}>{formatWeightForDisplay(props.weight, props.weightUnit)}</Typography>
                          </div>
                          <div style={styles.packageStat}>
                            <Typography style={styles.packageStatLabel}>RATE</Typography>
                            <Typography style={{...styles.packageStatValue, ...styles.packageStatRate}}>
                              {props.rate ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'CAD' }).format(props.rate.Rate) : 'N/A'}
                            </Typography>
                          </div>
                          {props.rate?.tax != null && (
                            <div style={styles.packageStat}>
                              <Typography style={styles.packageStatLabel}>TAX</Typography>
                              <Typography style={{...styles.packageStatValue, ...styles.packageStatRate}}>
                                {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'CAD' }).format(props.rate.tax)}
                              </Typography>
                            </div>
                          )}
                          {props.rate?.TotalRate != null && (
                            <div style={styles.packageStat}>
                              <Typography style={styles.packageStatLabel}>TOTAL</Typography>
                              <Typography style={{...styles.packageStatValue, ...styles.packageStatRate}}>
                                {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'CAD' }).format(props.rate.TotalRate)}
                              </Typography>
                            </div>
                          )}
                        </div>
                      </div>
                    </Grid>
                    {props.references.Reference && (
                      <Grid item xs={12}>
                        <OrderDetailsBox title="BILLING REF#" value={props.references.Reference} bold={true}/>
                      </Grid>
                    )}
                  </>
                )}
                
                {/* Instructions if any */}
                {props.instructions && (
                  <Grid item sm={12}>
                    <OrderDetailsBox title="INSTRUCTIONS" value={getIntructions()} bold={true}/>
                  </Grid>
                )}
            </Grid>
          </div>

            {/* Return Trip Details */}
            {props.returnTripService && (
              <ReturnTripDetailsBox 
                returnTripService={props.returnTripService}
                fromName={props.fromName}
                fromAddress={props.fromAddress}
                toName={props.toName}
                toAddress={props.toAddress}
              />
            )}
            
            {/* Order Summary - only shown if there's a return trip */}
            {props.returnTripService && (
              <OrderSummary
                packageSize={props.packageSize}
                packageImage={renderButtonImage()}
                pieces={props.pieces}
                pieceDescriptionOverride={props.pieceDescriptionOverride}
                weightUnit={props.weightUnit}
                weight={props.weight}
                tripRate={props.rate ? props.rate.Rate : 0}
                returnRate={props.returnTripService ? props.returnTripService.RATE : 0}
              />
            )}
        </div>
    );
};

export default OrderInfo;